export const keepOnlyNumericCaracters = (string) => {
  return string.replace(/\D/g, '');
};
